<template>
  <nav
    :class="classObject"
    @mouseover.stop="onMouseOver"
    @mouseout.stop="onMouseOut"
    @click="onMouseOver"
    role="navigation"
    aria-label="Main navigation"
  >
    <app-navigation-list :links="navItems"></app-navigation-list>
    <app-navigation-systems></app-navigation-systems>
  </nav>
</template>

<script>
import AppNavigationList from '@/components/AppNavigationList';
import AppNavigationSystems from '@/components/AppNavigationSystems';

export default {
  name: 'app-navigation',

  components: {
    AppNavigationList,
    AppNavigationSystems,
  },

  computed: {
    classObject() {
      return {
        'c-navigation': true,
        'is-open': this.isOpen,
        'is-closed': !this.isOpen,
      };
    },

    navItems() {
      // if admin is disabled, strip out from menu
      if (this.$adminDisabled) {
        return this.$store.state.navigation.items.filter(item => !item.to.includes('/admin'));
      }
      return this.$store.state.navigation.items;
    },

    isOpen() {
      return this.$store.state.navigation.isOpen;
    },
  },

  methods: {
    onMouseOver() {
      clearTimeout(this.mouseOutTimeout);
      this.$store.dispatch('navigation/openMenu');
    },

    onMouseOut() {
      this.mouseOutTimeout = setTimeout(() => {
        this.$store.dispatch('navigation/closeMenu');
      }, 600);
    },
  },
};
</script>

<style lang="scss">
.c-navigation {
  visibility: hidden;

  background: $colour-cactus-bright-green;

  width: 336px;

  position: fixed;
  top: 140px;
  bottom: 50px;
  left: 0;

  overflow: hidden;
  z-index: 30;
  padding-bottom: 55px;

  transform: translateX(-100%);
  transition: transform 0.3s 0.3s, visibility 0.3s 0.3s;
  ::-webkit-scrollbar {
    display: none;
  }
}

.c-navigation.is-open {
  visibility: visible;
  box-shadow: 4px 0px 40px rgba(0, 0, 0, 0.21);
  transform: translateX(0);
  ::-webkit-scrollbar {
    display: block;
  }
  ::-webkit-scrollbar-thumb {
    background: $colour-cactus-dark-green;
  }
}

.c-navigation ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

@media screen and (min-width: 640px) {
  .c-navigation {
    width: 336px;
    visibility: visible;
    opacity: 1;
    transform: translateX(-281px);
    bottom: 0;
    z-index: 30;
    transition-delay: 0.3s;
    @media (min-width: 1024px) {
      // top:  calc(1em + 140px);
    }
  }
  .c-navigation.is-open {
    transform: translateX(0);
    transition-delay: 0.1s;
  }
}
</style>
